import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Navigation } from '../components/Navigation';
import { ContextEngineeringPageHero } from '../components/ContextEngineeringPageHero';
import { ContextEngineeringHero } from '../components/ContextEngineeringHero';
import { ContextMissingPiece } from '../components/ContextMissingPiece';
import { HowContextWorks } from '../components/HowContextWorks';
import { CapturedContextExamples } from '../components/CapturedContextExamples';
import { ContextResults } from '../components/ContextResults';
import { ContextBenefits } from '../components/ContextBenefits';
import { ContextDemo } from '../components/ContextDemo';
import { ContextQualification } from '../components/ContextQualification';
export function ContextEngineeringPage() {
  return <div className="min-h-screen w-full bg-white selection:bg-[#0066FF] selection:text-white" data-id="element-2265">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-100" data-id="element-2266">
        <div className="w-full px-6 md:px-12 lg:px-24" data-id="element-2267">
          <div className="max-w-7xl mx-auto h-20 flex items-center" data-id="element-2268">
            <Link to="/" data-id="element-2269">
              <img src="https://cdn.magicpatterns.com/uploads/9qJGNjQNSV94689CCZT1kr/newTM_black_copy.png" alt="Synthia" className="h-8" data-id="element-2270" />
            </Link>
            <Navigation data-id="element-2271" />
          </div>
        </div>
      </header>

      <main data-id="element-2272">
        <ContextEngineeringPageHero data-id="element-2273" />
        <ContextEngineeringHero data-id="element-2274" />
        <ContextMissingPiece data-id="element-2275" />
        <HowContextWorks data-id="element-2276" />
        <CapturedContextExamples data-id="element-2277" />
        <ContextResults data-id="element-2278" />
        <ContextBenefits data-id="element-2279" />
        <ContextDemo data-id="element-2280" />
        <ContextQualification data-id="element-2281" />
      </main>

      <Footer data-id="element-2282" />
    </div>;
}